import React from "react";
import { ExperienceCancellationPolicy } from "halifax";
import { Box } from "@material-ui/core";
import { ExperiencesCancellationPolicy } from "redmond";

import { ShopComponentSkeleton } from "../../component";
import {
  AVAILABLE,
  getExperimentVariant,
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../../context/experiments";

export interface IShopCancellation {
  isSkeleton?: boolean;
  cancellationPolicy?: ExperiencesCancellationPolicy;
  startingTimeZone?: string;
}

export interface IShopCancellationPolicyProps extends IShopCancellation {
  selectedDate?: string | null;
  selectedTime?: string | null;
  startingTimeZone?: string;
}

const Skeleton = () => (
  <Box className="experiences-shop-skeleton">
    <Box className="section-wrapper">
      <ShopComponentSkeleton name="small" />
      <ShopComponentSkeleton name="large" />
      <ShopComponentSkeleton name="medium" />
    </Box>
  </Box>
);

export const ShopCancellationPolicy = (props: IShopCancellationPolicyProps) => {
  const {
    isSkeleton,
    cancellationPolicy,
    selectedDate,
    selectedTime,
    startingTimeZone,
  } = props;

  const expState = useExperiments();
  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  if (isSkeleton || !cancellationPolicy) {
    return <Skeleton />;
  }

  return (
    <ExperienceCancellationPolicy
      cancellationPolicy={cancellationPolicy}
      selectedDate={selectedDate}
      selectedTime={selectedTime}
      startingTimeZone={startingTimeZone}
      isXmodRedesign={isXmodRedesign}
    />
  );
};
